import { useEffect } from "react";
import { useLocation } from "react-router";

import { trackPageView } from "~/lib/gtag";

/**
 * Hook to track page views with Google Analytics
 * Fires on every route change
 */
export const useGtagPageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever location changes
    const path = location.pathname + location.search;
    trackPageView(path);
  }, [location]);
};

export default useGtagPageTracking;
